const apiBaseUrl =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:5000/api";

const buildAuthUrl = (path) => `${String(apiBaseUrl).replace(/\/$/, "")}/auth/${path}`;

const sendBeaconJson = (url, body) => {
  if (typeof navigator === "undefined" || typeof navigator.sendBeacon !== "function") {
    return false;
  }
  try {
    const blob = new Blob([JSON.stringify(body || {})], {
      type: "application/json",
    });
    return navigator.sendBeacon(url, blob);
  } catch (_) {
    return false;
  }
};

const postJson = async (url, token, body, keepalive = false) => {
  if (!token) return;
  try {
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": token,
      },
      body: JSON.stringify(body),
      keepalive,
    });
  } catch (error) {
    // best-effort only
  }
};

export const markAuthPresence = async (token, isOnline, keepalive = false) =>
  postJson(buildAuthUrl("presence"), token, { isOnline }, keepalive);

export const markAuthLogout = async (token, keepalive = false) => {
  if (!token) return;
  if (keepalive) {
    sendBeaconJson(buildAuthUrl("logout-beacon"), { token });
  }
  return postJson(buildAuthUrl("logout"), token, {}, keepalive);
};
